import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validator } from '@angular/forms';
import { FormService } from "../Services/form.service";
import { QuestionService } from "../Services/question.service";
import { QuestionControlService } from './question-control.service';


import * as constant from '../constant';

import { QuestionBase } from './question-base';
import { TextboxQuestion } from './question-textbox';
import { DropdownQuestion } from './question-dropdown';
import { RadioButtonQuestion } from './question-radiobutton';
import { CheckBoxQuestion } from './question-checkbox';
import { AddressQuestion } from './question-address';
import { MyModalService } from '../Services/modal-service.service';
import { AuthService } from '../Services/auth.service';



@Component({
  selector: 'app-enquete',
  templateUrl: './enquete.component.html',
  styleUrls: ['./enquete.component.css'],
  providers: [QuestionControlService]
})
export class EnqueteComponent implements OnInit {
  readonly TEXT_BOX = constant.TEXT_BOX;
  readonly NUMBER_BOX = constant.NUMBER_BOX;
  readonly MAIL_BOX = constant.MAIL_BOX;
  readonly DATE_BOX = constant.DATE_BOX;
  readonly TELL_BOX = constant.TELL_BOX;
  readonly RADIO = constant.RADIO_BUTTON;
  readonly CHECK_BOX = constant.CHECK_BOX;
  readonly SELECT = constant.SELECT_BOX;
  readonly ADDRESS = constant.ADDRESS_FORM;

  Prefectures: string[];

  categoryList: any[];
  answer: {
    user_code: number,
    date_time: string,
    question_no: number,
    answer: any,
  };

  user_list: any;
  user_code: number;

  constructor(
    private formService: FormService,
    private questionService: QuestionService,
    private qcs: QuestionControlService,
    private modal: MyModalService,
    public auth: AuthService
  ) {
    //都道府県取得
    this.Prefectures = this.formService.getPrefectures();
    //サーバからアンケート取得
    this.questionService.getQuestionList(0).subscribe(list => {
      this.createCategoryList(list)
    });

  }

  ngOnInit() {
    this.auth.getUserList(0).subscribe(res => {
      this.user_list = res;
    });
  }

  /**
   * アンケート項目名と内容の抽出
   * @param list SQLから取得したアンケートテーブル一覧
   */
  createCategoryList(list) {
    //カテゴリ種類抽出
    let temp = list.filter(function (item, i, self) {
      return (self.findIndex(function (item2) {
        return (item.question_no === item2.question_no)
      }) === i);
    });

    let tempList = [];
    temp.forEach(item => {
      let i = {
        question_no: item.question_no,
        question_category: item.question_category,
        questions: null,
        form: null,
      }
      tempList.push(i);
    });

    tempList.forEach(category => {
      let question = list.filter(function (item, index) {
        if (item.question_no == category.question_no) return true;
      });
      category.questions = this.createQuestionList(question);
      category.form = this.qcs.toFormGroup(category.questions);
    });

    this.categoryList = tempList;
  }

  //アンケート項目生成
  /**
   * 各項目のアンケート欄生成
   * @param list 質問リスト
   */
  createQuestionList(list) {
    let questions = [];

    list.forEach(question => {
      if (question.question_disabled_flag == 0) {

        //テキストボックス系
        if (question.question_answer_type == this.TEXT_BOX ||
          question.question_answer_type == this.NUMBER_BOX ||
          question.question_answer_type == this.MAIL_BOX ||
          question.question_answer_type == this.DATE_BOX ||
          question.question_answer_type == this.TELL_BOX
        ) {
          let type_no = question.question_answer_type;
          let type = 'text';
          if (type_no == this.TEXT_BOX) type = 'text';
          if (type_no == this.NUMBER_BOX) type = 'number';
          if (type_no == this.MAIL_BOX) type = 'email';
          if (type_no == this.DATE_BOX) type = 'date';
          if (type_no == this.TELL_BOX) type = 'tel';

          let q: QuestionBase<any> = new TextboxQuestion({
            value: '',
            key: question.question_sort,
            code: question.question_code,
            label: question.question_info,
            type: type,
            order: question.question_sort,
            placeholder: question.question_answer_items
          });
          questions.push(q);
        }

        //テキストボックス(ナンバー)
        if (question.question_answer_type == this.NUMBER_BOX) {
          let q: QuestionBase<any> = new TextboxQuestion({
            value: '',
            key: question.question_sort,
            code: question.question_code,
            label: question.question_info,
            type: 'number',
            order: question.question_sort,
            placeholder: question.question_answer_items
          });
          questions.push(q);
        }

        //ラジオボタン
        if (question.question_answer_type == this.RADIO) {
          let options = [];
          let value = [];
          question.question_answer_items.forEach(item => {
            let temp = { key: item, value: item };
            options.push(temp);
          });

          let q: QuestionBase<any> = new RadioButtonQuestion({
            key: question.question_sort,
            code: question.question_code,
            label: question.question_info,
            options: options,
            order: question.question_sort,
            other: question.question_other_flag
          });
          questions.push(q);
        }

        //チェックボックス
        if (question.question_answer_type == this.CHECK_BOX) {
          let options = [];
          let value = [];
          question.question_answer_items.forEach(item => {
            let temp = { key: item, value: item };
            options.push(temp);
          });


          let q: QuestionBase<any> = new CheckBoxQuestion({
            value: value,
            key: question.question_sort,
            code: question.question_code,
            label: question.question_info,
            options: options,
            order: question.question_sort,
            other: question.question_other_flag
          });
          questions.push(q);
        }

        //ドロップダウン
        if (question.question_answer_type == this.SELECT) {
          let options = [];
          question.question_answer_items.forEach(item => {
            let temp = { key: item, value: item };
            options.push(temp);
          });

          let q: QuestionBase<any> = new DropdownQuestion({
            key: question.question_sort,
            code: question.question_code,
            label: question.question_info,
            options: options,
            order: question.question_sort
          });
          questions.push(q);
        }

        //住所フォーム
        if (question.question_answer_type == this.ADDRESS) {
          let opts = [];
          this.Prefectures.forEach(pref => {
            let temp = { key: pref, value: pref };
            opts.push(temp);
          });

          let q: QuestionBase<any> = new AddressQuestion({
            key: question.question_sort,
            code: question.question_code,
            value: {
              zip: new FormControl(''),
              pref: new FormControl(''),
              city: new FormControl(''),
              street: new FormControl(''),
            },
            label: question.question_info,
            type: 'text',
            options: opts,
            order: question.question_sort,
          });
          questions.push(q);
        }
      }

    });

    return questions.sort((a, b) => a.order - b.order);
  }

  async submit() {

    let ans = [];
    this.categoryList.forEach(cate => {
      ans = ans.concat(cate.form.value);
    });

    //console.log(ans);

    let res = await this.modal.confirm('入力完了', 'アンケートの入力を完了させてもよろしいでしょうか？');
    if (!res) {
      return;
    }
    await this.modal.message('アンケート完了', 'ご協力ありがとうございました。端末を係員にお渡しください');


    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours();
    var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes();
    var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds();
    var datetime = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;

    this.answer = {
      user_code: null,
      date_time: datetime,
      question_no: 1,
      answer: ans,
    }

  }

  send() {
    this.answer.user_code = this.user_code;

    //console.log(this.answer);
    this.questionService.saveQuestionAnswer(this.answer).subscribe(res => {
      //console.log(res);
    });
  }
}
